import { getConfig } from '@/configs/config-accessor';
import { handleGetCollection } from '@/constants/db-collection.constants';
import ApiService from './ApiService';

// Get the API prefix from the config accessor
const getApiPrefix = () => getConfig().newApiPrefix;

export interface IProduct {
  _id: string;
  title: string;
  description: string;
  images: ProductImage[];
  variations: IProductVariation[];
}

export interface IProductVariation {
  _id: string;
  title: string;
  price: number;
  images: ProductImage[];
}

export type ProductImage = { _id: string; name: string; img: string };

export type CreateProduct_Body = Omit<IProduct, '_id'>;
export type CreateProduct_Response = IResponse<IProduct | null>;
export const createProduct = async (body: CreateProduct_Body) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<CreateProduct_Response, DynamicCreate_Body<CreateProduct_Body>>({ 
    url: `${newApiPrefix}/dynamic/create`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('product'), 
      data: body 
    } 
  });
};

export type UpdateProduct_Params = { _id: string };
export type UpdateProduct_Body = Partial<Omit<IProduct, '_id'>>;
export type UpdateProduct_Response = IResponse<IProduct | null>;
export const updateProduct = async (params: UpdateProduct_Params, body: UpdateProduct_Body) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<UpdateProduct_Response, DynamicUpdate_Body<UpdateProduct_Body>>({ 
    url: `${newApiPrefix}/dynamic/update`, 
    method: 'patch', 
    data: { 
      collection: handleGetCollection('product'), 
      filter: { _id: params._id }, 
      data: body 
    } 
  });
};

export type DeleteProduct_Params = { _id: string };
export type DeleteProduct_Response = IResponse<IProduct | null>;
export const deleteProduct = async (params: DeleteProduct_Params) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<DeleteProduct_Response, DynamicDelete_Body>({ 
    url: `${newApiPrefix}/dynamicmongodb/delete`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('product'), 
      filter: { _id: params._id } 
    } 
  });
};

export type SearchProduct_Response = IResponse<IProduct[] | null>;
export type SearchProduct_Query = { limit: number; searchText: string };
export const searchProducts = async (query: SearchProduct_Query) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<SearchProduct_Response, DynamicGet_Body>({ 
    url: `${newApiPrefix}/dynamic/get`, 
    method: 'post', 
    data: { 
      collection: handleGetCollection('product'), 
      filter: { title: { $regex: query.searchText } }, 
      limit: query.limit 
    } 
  });
};
